<!-- <div class="container"> -->
<div
  *ngIf="loadData"
  class="loaderContainer"
  style="
    background: rgb(0, 0, 0);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 908;
    opacity: 0.2;
  "
>
  <!-- <button class="btn btn-success" (click)="showSpinner()">Show spinner</button> -->

  <mat-progress-spinner
    mode="indeterminate"
    [diameter]="100"
    [strokeWidth]="5"
    color="accent"
    style="margin: 15% auto"
    class="spinner-3 loaderContent"
  >
  </mat-progress-spinner>
</div>

<form
  #formulaire="ngForm"
  [formGroup]="formulaireFormGroup"
  id="formulaire"
  [ngClass]="{ container: true, 'cursor-wait': loading }"
  *ngIf="personne"
>
  <p id="enteteformulaire">
    Souscription totalement sécurisée, rapide et sans questionnaire de santé
  </p>

  <div class="blocForm">
    <div class="sousTitre">
      <div class="cirlceSousTitre">
        <img [src]="'../../../../../../assets/img/' + avatar" alt="avatar" />
      </div>
      <div>
        <h3 class="titrePanel">Dites-nous en plus sur vous ...</h3>
      </div>
    </div>

    <div class="civilite">
      <span> Civilité </span>
      <div class="radio cR_theme" [ngClass]="choixRadio_theme">
        <span>
          <input
            [checked]="personne.sexe == '2'"
            value="2"
            [(ngModel)]="personne.sexe"
            type="radio"
            name="civilite"
            id="Mr"
            [ngModelOptions]="{ standalone: true }"
          />
          <label for="Mr"> Monsieur </label>
        </span>
        <span>
          <input
            [checked]="personne.sexe == '1'"
            value="1"
            [(ngModel)]="personne.sexe"
            type="radio"
            name="civilite"
            id="Mme"
            [ngModelOptions]="{ standalone: true }"
          />
          <label for="Mme"> Madame </label>
        </span>
      </div>
    </div>

    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label
            for="infoModalNom"
            [class.redLabel]="
              nomCtrl.invalid && (nomCtrl.dirty || nomCtrl.touched)
            "
          >
            Nom
            <span class="obligatoire">*</span></label
          >
        </p>
        <input
          formControlName="nomCtrl"
          class="input_style"
          type="text"
          name="firstName"
          id="infoModalNom"
          [(ngModel)]="personne.nom"
          [ngClass]="{
            redBorder: nomCtrl.invalid && (nomCtrl.dirty || nomCtrl.touched),
          }"
        />
        <p
          *ngIf="
            nomCtrl.hasError('required') ||
            nomCtrl.hasError('invalid') ||
            nomCtrl.hasError('pattern')
          "
          class="error-msg"
        >
          Nom invalide.
        </p>
      </div>
      <div class="FormDroite">
        <p>
          <label
            for="infoModalPrenom"
            [class.redLabel]="
              prenomCtrl.invalid && (prenomCtrl.dirty || prenomCtrl.touched)
            "
          >
            Prénom(s)<span class="obligatoire">*</span></label
          >
        </p>
        <input
          formControlName="prenomCtrl"
          class="input_style"
          type="text"
          name="prenom"
          id="infoModalPrenom"
          [(ngModel)]="personne.prenom"
          [ngClass]="{
            redBorder:
              prenomCtrl.invalid && (prenomCtrl.dirty || prenomCtrl.touched),
          }"
        />
        <p
          *ngIf="
            prenomCtrl.hasError('required') ||
            prenomCtrl.hasError('invalid') ||
            prenomCtrl.hasError('pattern')
          "
          class="error-msg"
        >
          Prénom invalide.
        </p>
      </div>
    </div>
    <div class="ligneForm">
      <div class="FormGauche">
        <!-- <div class="groupInput"> -->
        <label for="debutContrat"
          >Date de naissance <span class="obligatoire">*</span></label
        >
        <input
          type="date"
          name="dateNaissanceAssure"
          class="input_style"
          id="infoModalDateNaiss"
          [(ngModel)]="personne.dateNaissanceAssure"
          min="{{ DateNaissanceMin | date: 'yyyy-MM-dd' }}"
          max="{{ DateNaissanceMax | date: 'yyyy-MM-dd' }}"
          [required]="true"
          [disabled]="true"
          [ngModelOptions]="{ standalone: true }"
        />
        <!--
          <p
            *ngIf="personne.dateNaissanceAssure > formatDateNaissanceMax && personne.dateNaissanceAssure.length > 0"
            class="error-msg   child18 erreurAffiche"
          >
            Vous devez avoir plus de 18 ans pour souscrire un contrat santé.
          </p>
          <p
            *ngIf="personne.dateNaissanceAssure < formatDateNaissanceMin && personne.dateNaissanceAssure.length > 0"
            class="error-msg   child18 erreurAffiche"
          >
            Nous sommes désolés mais nous n’avons pas d’offre pour les plus de 90 ans.
          </p> -->
        <!-- </div> -->
      </div>
      <!-- Secu social -->
      <div class="FormDroite">
        <div style="display: flex">
          <p>
            <label
              for="assuree_sec_s"
              [ngClass]="{
                redLabel:
                  secuCtrl.invalid && (secuCtrl.dirty || secuCtrl.touched),
              }"
            >
              N° de sécurité sociale
              <span class="obligatoire">*&nbsp;&nbsp;</span></label
            >
          </p>
          <div class="infobulle">
            <img src="assets/img/info.png" alt="Information" />
            <span class="infobulletext">
              <span class="mentionObg">
                <small for="">Exemple de format : 2 94 03 75 120 005 22</small>
              </span>
            </span>
          </div>
        </div>

        <p>
          <input
            formControlName="secuCtrl"
            [(ngModel)]="numSecuSocial"
            name="inputSecuriteSociale"
            type="number"
            inputmode="numeric"
            class="input_style"
            id="assuree_sec_s"
            [ngClass]="{
              redBorder:
                secuCtrl.invalid && (secuCtrl.dirty || secuCtrl.touched),
            }"
          />
        </p>
        <p
          *ngIf="
            (secuCtrl.hasError('required') || secuCtrl.hasError('pattern')) &&
            (secuCtrl.dirty || secuCtrl.touched) &&
            !isNumSecuSocialeValid(numSecuSocial)
          "
          class="error-msg erreurAffiche"
        >
          N° de sécurité sociale invalide.
        </p>
      </div>
    </div>
    <div class="ligneForm">
      <div class="FormGauche">
        <label
          for="profession"
          [class.redLabel]="
            professionCtrl.invalid &&
            (professionCtrl.dirty || professionCtrl.touched)
          "
          >Profession <span class="obligatoire">*</span></label
        >
        <input
          formControlName="professionCtrl"
          type="text"
          name="profession"
          id="profession"
          [(ngModel)]="souscription.professionSouscripteur"
          class="input_style"
          [class.redBorder]="
            professionCtrl.invalid &&
            (professionCtrl.dirty || professionCtrl.touched)
          "
        />
        <p
          *ngIf="
            professionCtrl.hasError('required') &&
            (professionCtrl.touched || professionCtrl.dirty)
          "
          class="error-msg erreurAffiche"
        >
          Le champ profession est obligatoire
        </p>
      </div>
      <div class="FormDroite">
        <p>
          <label
            for="infoModalRegime"
            [ngClass]="{
              redLabel: cspCtrl.invalid && (cspCtrl.dirty || cspCtrl.touched),
            }"
          >
            CSP <span class="obligatoire">*</span></label
          >
        </p>
        <select
          formControlName="cspCtrl"
          id="infoModalRegime"
          name="csp"
          [(ngModel)]="assuree.assurePrincipal.csp"
        >
          <option value="">votre choix</option>
          <option *ngFor="let item of listeCsp; let i = index" [ngValue]="item">
            {{ item }}
          </option>
        </select>

        <p
          *ngIf="
            cspCtrl.hasError('required') && (cspCtrl.touched || cspCtrl.dirty)
          "
          class="error-msg erreurAffiche"
        >
          Le champ CSP est obligatoire
        </p>
      </div>
    </div>

    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label
            [ngClass]="{
              redLabel:
                paysCtrl.invalid && (paysCtrl.dirty || paysCtrl.touched),
            }"
          >
            Pays de naissance <span class="obligatoire">*</span></label
          >
        </p>
        <p>
          <input
            formControlName="paysCtrl"
            [(ngModel)]="assuree.paysNaissance"
            name="paysNaissance"
            type="text"
            class="input_style"
            [ngClass]="{
              redBorder:
                paysCtrl.invalid && (paysCtrl.dirty || paysCtrl.touched),
            }"
          />
        </p>
        <p
          *ngIf="
            paysCtrl.hasError('required') &&
            (paysCtrl.dirty || paysCtrl.touched)
          "
          class="error-msg erreurAffiche"
        >
          Le pays de naissance est obligatoire.
        </p>
      </div>
      <div class="FormDroite">
        <p>
          <label> Lieu de naissance </label>
        </p>
        <p>
          <input
            #inputLieu="ngModel"
            [(ngModel)]="lieuNaissance"
            name="lieuNaissance"
            [placeholder]="getPaysPlaceHolder(assuree.paysNaissance)"
            type="text"
            class="input_style"
            [ngModelOptions]="{ standalone: true }"
          />
        </p>
      </div>
    </div>
    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label
            for="infoModalEmail"
            [ngClass]="{
              redLabel:
                emailCtrl.invalid ||
                (emailInvalide(personne.email) &&
                  (emailCtrl.dirty || emailCtrl.touched)),
            }"
          >
            Email <span class="obligatoire">*</span></label
          >
        </p>

        <input
          formControlName="emailCtrl"
          type="email"
          class="input_style"
          name="inputEmail"
          id=""
          [(ngModel)]="personne.email"
          [ngClass]="{
            redBorder:
              emailCtrl.invalid ||
              (emailInvalide(personne.email) &&
                (emailCtrl.dirty || emailCtrl.touched)),
          }"
        />

        <p
          *ngIf="
            (emailCtrl.hasError('required') ||
              emailCtrl.hasError('pattern') ||
              emailInvalide(personne.email)) &&
            (emailCtrl.dirty || emailCtrl.touched)
          "
          class="error-msg erreurAffiche"
        >
          Veuillez renseigner un email valide.
        </p>
      </div>

      <div class="FormDroite">
        <p>
          <label
            [ngClass]="{
              redLabel:
                (telephoneInvalide() || phoneControl.invalid) &&
                (phoneControl.dirty || phoneControl.touched),
            }"
          >
            Téléphone (fixe ou mobile) <span class="obligatoire">*</span></label
          >
        </p>
        <p>
          <input
            class="input_style"
            type="text"
            name="telephone"
            id="infoModelTelephone"
            inputmode="numeric"
            formControlName="phoneControl"
            minlength="10"
            maxlength="13"
            [(ngModel)]="personne.telephone"
            [ngClass]="{
              redBorder:
                (telephoneInvalide() || phoneControl.invalid) &&
                (phoneControl.dirty || phoneControl.touched),
            }"
          />
        </p>

        <p
          *ngIf="
            phoneControl.hasError('pattern') ||
            phoneControl.hasError('required') ||
            telephoneInvalide()
          "
          class="error-msg erreurAffiche"
        >
          Veuillez renseigner un téléphone valide.
        </p>
      </div>
    </div>
    <div class="ligneForm" *ngIf="personne && personne.codeParrain">
      <div class="FormGauche">
        <p>
          <label
            for="infoModalCodeParrain"
            [ngClass]="{
              redLabel:
                codeParrainCtrl.invalid &&
                (codeParrainCtrl.dirty || codeParrainCtrl.touched),
            }"
            >Code parrain</label
          >
        </p>

        <input
          formControlName="codeParrainCtrl"
          type="text"
          class="input_style"
          name="inputCodeParrain"
          id=""
          [(ngModel)]="personne.codeParrain"
          [ngClass]="{
            redBorder:
              codeParrainCtrl.invalid ||
              codeParrainCtrl.dirty ||
              codeParrainCtrl.touched,
          }"
          [disabled]="true"
        />
      </div>
      <div class="FormDroite">
        <p></p>
      </div>
    </div>
  </div>

  <div class="blocForm">
    <div class="sousTitre">
      <div class="cirlceSousTitre">
        <img
          class="widthCirlceSousTitre"
          [src]="'../../../../../../assets/img/' + location"
          alt="avatar"
        />
      </div>
      <div>
        <h3>Où habitez-vous ?</h3>
      </div>
    </div>
    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label
            [ngClass]="{
              redLabel:
                adressePostaleCtrl.invalid &&
                (adressePostaleCtrl.dirty || adressePostaleCtrl.touched),
            }"
          >
            Adresse postale <span class="obligatoire">*</span></label
          >
        </p>
        <p>
          <input
            formControlName="adressePostaleCtrl"
            [(ngModel)]="adressePostale"
            name="adressePostale"
            type="text"
            class="input_style"
            [ngClass]="{
              redBorder:
                adressePostaleCtrl.invalid &&
                (adressePostaleCtrl.dirty || adressePostaleCtrl.touched),
            }"
          />
        </p>
        <p
          *ngIf="
            adressePostaleCtrl.hasError('required') &&
            (adressePostaleCtrl.touched || adressePostaleCtrl.dirty)
          "
          class="error-msg erreurAffiche"
        >
          L'adresse postale est obligatoire.
        </p>
        <p *ngIf="addWaringAddress != ''" class="error-msg erreurAffiche">
          {{ addWaringAddress }}
        </p>
      </div>
      <div class="FormDroite">
        <p>
          <label>Complément d’adresse </label>
        </p>
        <p>
          <input
            #inputComplement="ngModel"
            [(ngModel)]="complementAdresse"
            type="text"
            class="input_style"
            name="complement"
            [ngModelOptions]="{ standalone: true }"
          />
        </p>
      </div>
    </div>
    <!-- <div class="ligneForm">
      <div class="FormPlein w-100">
        <p>
          <label>Complément d’adresse </label>
        </p>
        <p>
          <input
            #inputComplement="ngModel"
            [(ngModel)]="complementAdresse"
            type="text"
            class="input_style"
            name="complement"
            [ngModelOptions]="{ standalone: true }"
          />
        </p>
      </div>
    </div> -->
    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label> Code postal <span class="obligatoire">*</span></label>
        </p>
        <p>
          <input
            formControlName="codePostaleCtrl"
            inputmode="numeric"
            class="input_style"
            type="text"
            name="codepostal"
            mask="00000"
            id="infoModelCodePostal"
            [(ngModel)]="personne.codePostal"
          />
        </p>
        <p
          *ngIf="addWaringPostalCode != ''"
          class="error-msg erreurAffiche informatifmessage"
        >
          {{ addWaringPostalCode }}
        </p>
      </div>
      <div class="FormDroite">
        <p>
          <label
            [ngClass]="{
              redLabel:
                villeCtrl.invalid && (villeCtrl.dirty || villeCtrl.touched),
            }"
          >
            Ville <span class="obligatoire">*</span>
          </label>
        </p>
        <p>
          <select
            formControlName="villeCtrl"
            id="infoModalRegime"
            [(ngModel)]="ville"
          >
            <option value="">Choisissez votre ville :</option>
            <option
              *ngFor="
                let item of listvillesFilteredByCodepostale;
                let i = index
              "
              [ngValue]="item.ville"
            >
              {{ item.ville }}
            </option>
          </select>
        </p>
        <p
          *ngIf="
            villeCtrl.hasError('required') &&
            (villeCtrl.dirty || villeCtrl.touched)
          "
          class="error-msg erreurAffiche"
        >
          La ville est obligatoire.
        </p>
        <p *ngIf="villeExist == false" class="error-msg erreurAffiche">
          Aucune ville correspondante.
        </p>
        <p
          *ngIf="addWaringVille != ''"
          class="error-msg erreurAffiche informatifmessage"
        >
          {{ addWaringVille }}
        </p>
        <!-- listvillesFilteredByCodepostale{{listAdresses[0].codePostale}}-{{listAdresses[0].ville}} <br />-->
        <!-- villeExist : {{villeExist}}<br />
                <button (click)="filterVillesByCodePostale(personne.codePostal)">FILTER VILLE BY CODEPOSTAL</button> -->
      </div>
    </div>
  </div>

  <div class="blocForm">
    <div class="sousTitre">
      <div class="cirlceSousTitre">
        <img [src]="'../../../../../../assets/img/' + social" alt="avatar" />
      </div>
      <div>
        <h3>Votre régime social ?</h3>
      </div>
    </div>
    <!-- </div> -->

    <div class="ligneForm">
      <div class="FormGauche">
        <p>
          <label for="infoModalRegime">Régime social </label>
        </p>
        <input
          [(ngModel)]="regimeSocialSouscripteur"
          name="regimeSocial"
          type="text"
          class="input_style"
          [disabled]="true"
          [ngModelOptions]="{ standalone: true }"
        />
        <!-- <select
        id="infoModalRegime"
        name="regimeSocial"
        [(ngModel)]="personne.regimeSocial"
        [disabled]="true"
        [ngModelOptions]="{ standalone: true }"
      >
        <option [ngValue]="'0'">Régime général</option>
        <option [ngValue]="'1'">Travailleur non salarié </option>
        <option [ngValue]="'2'"> Sécurité sociale agricole </option>
        <option [ngValue]="'3'">Alsace-moselle</option>
      </select> -->
      </div>
      <div class="FormDroite">
        <div style="display: flex">
          <label
            [ngClass]="{
              redLabel:
                !isCodeOrganisme(
                  assuree.assurePrincipal.noOrga,
                  assuree.assurePrincipal.orga
                ) &&
                (caisseCtrl.dirty || caisseCtrl.touched),
            }"
          >
            Code organisme
            <span class="obligatoire">*&nbsp;&nbsp;</span>
          </label>
          <div class="infobulle">
            <img src="assets/img/info.png" alt="" />
            <span class="infobulletext">
              <span class="mentionObg">
                <small for="">
                  Votre code organisme figure sur votre attestation d'Assurance
                  Maladie Obligatoire sous la forme de chiffres tel que 01 741
                  5143</small
                >
              </span>
            </span>
          </div>
        </div>

        <p>
          <input
            formControlName="caisseCtrl"
            [(ngModel)]="assuree.assurePrincipal.orga"
            name="caisse"
            type="text"
            class="input_style"
            mask="000000000"
            [ngClass]="{
              redBorder:
                !isCodeOrganisme(
                  assuree.assurePrincipal.noOrga,
                  assuree.assurePrincipal.orga
                ) &&
                (caisseCtrl.dirty || caisseCtrl.touched),
            }"
          />
        </p>

        <p>
          <input
            id="je_transmettrai"
            type="checkbox"
            name="noorga"
            [(ngModel)]="assuree.assurePrincipal.noOrga"
            [ngModelOptions]="{ standalone: true }"
            style="width: 30px; height: 1em"
          />
          <label for="je_transmettrai" class="mentionObg"
            >Je transmettrai mon code organisme ultérieurement afin de
            bénéficier de la télétransmission.
          </label>
        </p>
        <!-- {{ isCodeOrganisme(assuree.assurePrincipal.noOrga) }} -->
        <p
          *ngIf="
            (caisseCtrl.dirty || caisseCtrl.touched) &&
            !isCodeOrganisme(
              assuree.assurePrincipal.noOrga,
              assuree.assurePrincipal.orga
            )
          "
          class="error-msg erreurAffiche"
        >
          Vous devez renseigner un code organisme ou cocher la case.
        </p>
      </div>
    </div>
  </div>

  <!-- CONJOINTS -->
  <div class="blocForm" *ngIf="displayconjoint" formArrayName="conjoint">
    <div
      *ngFor="let item of conjoint().controls; let i = index"
      [formGroupName]="i"
    >
      <div class="sousTitre">
        <div class="cirlceSousTitre">
          <img
            [src]="'../../../../../../assets/img/' + beneficiaire"
            alt="avatar"
          />
        </div>
        <div>
          <h3>Vos bénéficiaires</h3>
        </div>
      </div>
      <!-- </div> -->

      <h4>Conjoint</h4>
      <div class="civilite">
        <span> Civilité </span>
        <div class="radio cR_theme" [ngClass]="choixRadio_theme">
          <span>
            <input
              [checked]="assuree.assureConjoint.sexe == '2'"
              [(ngModel)]="assuree.assureConjoint.sexe"
              type="radio"
              name="civiliteConjoint2"
              id="conjoint"
              value="2"
              [ngModelOptions]="{ standalone: true }"
            />
            <label for="conjoint"> Monsieur </label>
          </span>
          <span>
            <input
              [checked]="assuree.assureConjoint.sexe == '1'"
              [(ngModel)]="assuree.assureConjoint.sexe"
              type="radio"
              name="civiliteConjoint2"
              id="conjointe"
              value="1"
              [ngModelOptions]="{ standalone: true }"
            />
            <label for="conjointe"> Madame </label>
          </span>
        </div>
      </div>
      <div class="ligneForm">
        <div class="FormGauche">
          <p>
            <label
              [ngClass]="{
                redLabel:
                  nomConjointCtrl.invalid &&
                  (nomConjointCtrl.dirty || nomConjointCtrl.touched),
              }"
            >
              Nom <span class="obligatoire"> *</span></label
            >
          </p>
          <input
            class="input_style"
            formControlName="nomConjointCtrl"
            type="text"
            name="nomConjoint"
            id="infoModalNom"
            [(ngModel)]="assuree.assureConjoint.nom"
            [ngClass]="{
              redBorder:
                nomConjointCtrl.invalid &&
                (nomConjointCtrl.dirty || nomConjointCtrl.touched),
            }"
          />
          <p
            *ngIf="
              nomConjointCtrl.invalid &&
              (nomConjointCtrl.dirty || nomConjointCtrl.touched)
            "
            class="error-msg child18 erreurAffiche"
          >
            Le nom du conjoint(e) est invalide.
          </p>
        </div>
        <div class="FormDroite">
          <p>
            <label
              for="prenom"
              [ngClass]="{
                redLabel:
                  prenomConjointCtrl.invalid &&
                  (prenomConjointCtrl.dirty || prenomConjointCtrl.touched),
              }"
            >
              Prénom(s) <span class="obligatoire"> *</span></label
            >
          </p>
          <input
            class="input_style"
            formControlName="prenomConjointCtrl"
            type="text"
            name="prenomConjoint"
            id="infoModalNom"
            [(ngModel)]="assuree.assureConjoint.prenom"
            [ngClass]="{
              redBorder:
                prenomConjointCtrl.invalid &&
                (prenomConjointCtrl.dirty || prenomConjointCtrl.touched),
            }"
          />
          <p
            *ngIf="
              prenomConjointCtrl.invalid &&
              (prenomConjointCtrl.dirty || prenomConjointCtrl.touched)
            "
            class="error-msg child18 erreurAffiche"
          >
            Le prénom du conjoint(e) invalide.
          </p>
        </div>
      </div>

      <div class="ligneForm">
        <div class="FormGauche">
          <p>
            <label>
              Date de naissance <span class="obligatoire"> *</span></label
            >
          </p>
          <p>
            <input
              type="date"
              name="dateNaissanceConjoint"
              id="infoModalDateNaiss"
              class="input_style"
              [(ngModel)]="assuree.assureConjoint.dateNaissance"
              min="{{ DateNaissanceMin | date: 'yyyy-MM-dd' }}"
              max="{{ DateNaissanceMax | date: 'yyyy-MM-dd' }}"
              [required]="true"
              [disabled]="true"
              [ngModelOptions]="{ standalone: true }"
            />
          </p>
        </div>
        <div class="FormDroite">
          <p>
            <label for="prenom"> Régime social</label>
          </p>
          <p>
            <input
              name="conjointRegime"
              type="text"
              class="input_style"
              [value]="conjointRegimeConverter()"
              [disabled]="true"
            />
          </p>
        </div>
      </div>
      <div class="ligneForm">
        <!-- Secu conjoint -->
        <div class="FormGauche">
          <p>
            <label
              for="assuree_conjoint_sec_s"
              [ngClass]="{
                redLabel:
                  secuConjointCtrl.invalid &&
                  (secuConjointCtrl.dirty || secuConjointCtrl.touched),
              }"
            >
              N° de sécurité sociale <span class="obligatoire">*</span></label
            >
          </p>
          <p>
            <input
              formControlName="secuConjointCtrl"
              [(ngModel)]="assuree.assureConjoint.num_SS"
              name="inputSecuriteSociale"
              inputmode="numeric"
              type="number"
              id="assuree_conjoint_sec_s"
              class="input_style"
              [ngClass]="{
                redBorder:
                  secuConjointCtrl.invalid &&
                  (secuConjointCtrl.dirty || secuConjointCtrl.touched),
              }"
            />
          </p>
          <p
            *ngIf="
              secuConjointCtrl.invalid &&
              secuConjointCtrl.touched &&
              !isNumSecuSocialeValid(assuree.assureConjoint.num_SS)
            "
            class="error-msg erreurAffiche"
          >
            N° de sécurité sociale invalide.
          </p>
        </div>
        <!-- CSP Conjoint -->
        <div class="FormDroite">
          <p>
            <label
              [ngClass]="{
                redLabel: cspConjointCtrl.invalid && cspConjointCtrl.touched,
              }"
              for="infoModalRegime"
            >
              CSP <span class="obligatoire">*</span></label
            >
          </p>
          <select
            formControlName="cspConjointCtrl"
            id="infoModalRegime"
            name="cspConjoint"
            [(ngModel)]="assuree.assureConjoint.csp"
          >
            <option value="">votre choix</option>
            <option
              *ngFor="let item of listeCsp; let i = index"
              [ngValue]="item"
            >
              {{ item }}
            </option>
          </select>

          <p
            *ngIf="cspConjointCtrl.invalid && cspConjointCtrl.touched"
            class="error-msg erreurAffiche"
          >
            Le champ CSP est obligatoire
          </p>
        </div>
      </div>

      <div class="ligneForm">
        <div class="FormGauche">
          <p>
            <label
              [ngClass]="{
                redLabel:
                  paysConjointCtrl.invalid &&
                  (paysConjointCtrl.dirty || paysConjointCtrl.touched),
              }"
            >
              Pays de naissance <span class="obligatoire">*</span></label
            >
          </p>
          <p>
            <input
              formControlName="paysConjointCtrl"
              [(ngModel)]="paysNaissanceConjoint"
              name="paysNaissanceConjoint"
              type="text"
              class="input_style"
              [ngClass]="{
                redBorder:
                  paysConjointCtrl.invalid &&
                  (paysConjointCtrl.dirty || paysConjointCtrl.touched),
              }"
            />
          </p>
          <p
            *ngIf="
              paysConjointCtrl.hasError('required') &&
              (paysConjointCtrl.dirty || paysConjointCtrl.touched)
            "
            class="error-msg erreurAffiche"
          >
            Le pays de naissance est obligatoire.
          </p>
        </div>

        <div class="FormDroite">
          <p>
            <label> Lieu de naissance </label>
          </p>
          <p>
            <input
              #inputLieuConjoint="ngModel"
              [(ngModel)]="lieuNaissanceConjoint"
              name="lieuNaissanceConjoint"
              [placeholder]="getPaysPlaceHolder(paysNaissanceConjoint)"
              type="text"
              class="input_style"
              [ngModelOptions]="{ standalone: true }"
            />
          </p>
          <!-- <p *ngIf="inputLieuConjoint.invalid && inputLieuConjoint.touched" class="error-msg erreurAffiche">
                        Le lieu de naissance est obligatoire.
                    </p> -->
        </div>
      </div>

      <div class="ligneForm">
        <div class="FormGauche">
          <div style="display: flex">
            <label
              [ngClass]="{
                redLabel:
                  (caisseConjointCtrl.dirty || caisseConjointCtrl.touched) &&
                  !isCodeOrganisme(
                    assuree.assureConjoint.noOrga,
                    assuree.assureConjoint.orga
                  ),
              }"
            >
              Code organisme
              <span class="obligatoire">*&nbsp;&nbsp;</span>
            </label>
            <div class="infobulle">
              <img src="assets/img/info.png" alt="" />
              <span class="infobulletext">
                <span class="mentionObg">
                  <small for="">
                    Votre code d'organisme figure sur votre attestation
                    d'Assurance Maladie Obligatoire sous la forme d'un chiffre
                    tel que 01 741 5143</small
                  >
                </span>
              </span>
            </div>
          </div>
          <!-- <p>
            <label> Code d'organisme <span class="obligatoire"> *</span></label>
          </p> -->
          <p>
            <input
              formControlName="caisseConjointCtrl"
              [(ngModel)]="assuree.assureConjoint.orga"
              name="caisseConjoint"
              type="text"
              class="input_style"
              mask="000000000"
              [ngClass]="{
                redBorder:
                  (caisseConjointCtrl.dirty || caisseConjointCtrl.touched) &&
                  !isCodeOrganisme(
                    assuree.assureConjoint.noOrga,
                    assuree.assureConjoint.orga
                  ),
              }"
            />
          </p>

          <p>
            <input
              type="checkbox"
              name="noorga"
              [(ngModel)]="assuree.assureConjoint.noOrga"
              [ngModelOptions]="{ standalone: true }"
              style="width: 30px; height: 1em"
            />
            <label for="" class="mentionObg"
              >Je transmettrai mon code organisme ultérieurement afin de
              bénéficier de la télétransmission.
            </label>
          </p>
          <p
            *ngIf="
              caisseConjointCtrl.invalid &&
              (caisseConjointCtrl.dirty || caisseConjointCtrl.touched) &&
              !isCodeOrganisme(
                assuree.assureConjoint.noOrga,
                assuree.assureConjoint.orga
              )
            "
            class="error-msg erreurAffiche"
          >
            Vous devez renseigner un code organisme ou cocher la case.
          </p>
        </div>
        <div class="FormDroite"></div>
      </div>
    </div>
  </div>

  <!-- Enfants -->

  <div *ngIf="displayEnfant" id="formulaireEnfants">
    <div class="sousTitre">
      <div class="cirlceSousTitre">
        <img [src]="'../../../../../../assets/img/' + avatar" alt="avatar" />
      </div>
      <div>
        <h3>Enfants</h3>
      </div>
    </div>

    <div formArrayName="dateNaissanceEnfant">
      <div
        *ngFor="let item of dateNaissanceEnfant().controls; let i = index"
        [formGroupName]="i"
      >
        <ng-container *ngIf="assuree.assureEnfants[i]">
          <div class="civilite">
            <span> Civilité </span>
            <div class="radio d-flex cR_theme" [ngClass]="choixRadio_theme">
              <span class="d-flex">
                <input
                  [checked]="
                    !assuree.assureEnfants[i].sexe ||
                    assuree.assureEnfants[i].sexe == '2'
                  "
                  [(ngModel)]="assuree.assureEnfants[i].sexe"
                  type="radio"
                  [name]="'civiliteEnfant_' + i"
                  [id]="'civiliteEnfant_' + i"
                  value="2"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label [for]="'civiliteEnfant_' + i">Masculin</label>
              </span>
              <span class="d-flex">
                <input
                  [checked]="assuree.assureEnfants[i].sexe == '1'"
                  [(ngModel)]="assuree.assureEnfants[i].sexe"
                  type="radio"
                  [name]="'civiliteEnfant_' + i"
                  [id]="'civiliteEnfant_f' + i"
                  value="1"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label [for]="'civiliteEnfant_f' + i">Féminin</label>
              </span>
            </div>
          </div>
          <div class="ligneForm">
            <div class="FormGauche">
              <p>
                <label
                  [ngClass]="{
                    redLabel:
                      item.get('nom_ctrl')?.invalid &&
                      item.get('nom_ctrl')?.dirty,
                  }"
                >
                  Nom <span class="obligatoire"> *</span></label
                >
              </p>
              <p>
                <input
                  formControlName="nom_ctrl"
                  type="text"
                  class="input_style"
                  [(ngModel)]="assuree.assureEnfants[i].nom"
                  [ngClass]="{
                    redBorder:
                      item.get('nom_ctrl')?.invalid &&
                      item.get('nom_ctrl')?.dirty,
                  }"
                />
              </p>
              <p
                *ngIf="
                  item.get('nom_ctrl')?.invalid && item.get('nom_ctrl')?.dirty
                "
                class="error-msg"
              >
                Le nom d'enfant est invalide
              </p>
            </div>
            <div class="FormDroite">
              <p>
                <label
                  for="prenom"
                  [ngClass]="{
                    redLabel:
                      item.get('prenom_ctrl')?.invalid &&
                      item.get('prenom_ctrl')?.dirty,
                  }"
                >
                  Prénom(s) <span class="obligatoire"> *</span></label
                >
              </p>
              <p>
                <input
                  formControlName="prenom_ctrl"
                  type="text"
                  class="input_style"
                  [(ngModel)]="assuree.assureEnfants[i].prenom"
                  [ngClass]="{
                    redLabel:
                      item.get('prenom_ctrl')?.invalid &&
                      item.get('prenom_ctrl')?.dirty,
                  }"
                />
              </p>
              <p
                *ngIf="
                  item.get('prenom_ctrl')?.invalid &&
                  item.get('prenom_ctrl')?.dirty
                "
                class="error-msg"
              >
                Le(s) prénom(s) d'enfant invalide
              </p>
            </div>
            <div class="FormGauche">
              <p>
                <label>
                  Date de naissance <span class="obligatoire">*</span></label
                >
              </p>
              <p>
                <input
                  formControlName="date_enfant_ctrl"
                  type="date"
                  class="form-control input_style"
                  [disabled]="true"
                  [(ngModel)]="personne.enfant.dateNaissanceEnfant[i]"
                />
              </p>
            </div>
          </div>
          <div class="ligneForm">
            <div class="FormGauche">
              <p>
                <label
                  [ngClass]="{
                    redLabel:
                      item.get('paysEnfantCtrl')?.invalid &&
                      (item.get('paysEnfantCtrl')?.dirty ||
                        item.get('paysEnfantCtrl')?.touched),
                  }"
                >
                  Pays de naissance <span class="obligatoire">*</span></label
                >
              </p>
              <p>
                <input
                  formControlName="paysEnfantCtrl"
                  [(ngModel)]="paysLieuNaissanceData.enfants[i].paysNaissance"
                  [name]="'paysNaissanceEnfant_' + i"
                  type="text"
                  class="input_style"
                  [ngClass]="{
                    redBorder:
                      item.get('paysEnfantCtrl')?.invalid &&
                      (item.get('paysEnfantCtrl')?.dirty ||
                        item.get('paysEnfantCtrl')?.touched),
                  }"
                />
              </p>
              <p
                *ngIf="
                  item.get('paysEnfantCtrl')?.invalid &&
                  (item.get('paysEnfantCtrl')?.dirty ||
                    item.get('paysEnfantCtrl')?.touched)
                "
                class="error-msg erreurAffiche"
              >
                Le pays de naissance enfant est obligatoire.
              </p>
            </div>
            <div class="FormDroite">
              <p>
                <label> Lieu de naissance </label>
              </p>
              <p>
                <input
                  [(ngModel)]="paysLieuNaissanceData.enfants[i].lieuNaissance"
                  [name]="'lieuNaissanceEnfant_' + i"
                  [placeholder]="
                    getPaysPlaceHolder(
                      paysLieuNaissanceData.enfants[i].paysNaissance
                    )
                  "
                  type="text"
                  class="input_style"
                  [ngModelOptions]="{ standalone: true }"
                />
              </p>
            </div>
          </div>
          <div class="ligneForm">
            <div id="agree">
              <input
                type="checkbox"
                [name]="'enfantayantdroit' + i"
                [(ngModel)]="isCheckedAyantDroit"
                [ngModelOptions]="{ standalone: true }"
                style="width: 30px; height: 1em"
                (change)="onClickAyantDroit()"
              />
              <label> Ayant droit</label>
            </div>
          </div>
          <div
            class="civilite"
            *ngIf="assuree.assureEnfants[i].ayantDroit == true"
          >
            <label>
              Ayant droit de
              <span style="color: #cc0000">*</span>:&nbsp;&nbsp;&nbsp;</label
            >
            <div class="radio d-flex cR_theme" [ngClass]="choixRadio_theme">
              <span class="d-flex">
                <input
                  [(ngModel)]="ayantDroitVia"
                  [checked]="ayantDroitVia == '1' || !ayantDroitVia"
                  type="radio"
                  [name]="'ayantDroit_' + i"
                  [id]="'ayantDroit_' + i"
                  value="1"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label [for]="'ayantDroit_' + i">Vous</label>
              </span>
              <span class="d-flex" *ngIf="personne.compositionFamiliale != '2'">
                <input
                  [checked]="ayantDroitVia == '2'"
                  [(ngModel)]="ayantDroitVia"
                  type="radio"
                  [name]="'ayantDroit_' + i"
                  [id]="'ayantDroit_conjoint_' + i"
                  value="2"
                  [ngModelOptions]="{ standalone: true }"
                />
                <label [for]="'ayantDroit_conjoint_' + i">Votre conjoint</label>
              </span>
            </div>
          </div>
          <!-- <div *ngIf="!assuree.assureEnfants[i].ayantDroit">
            <div class="ligneForm">
                <div class="FormGauche">
                <p>
                    <label for="infoModalRegime"> CSP <span class="obligatoire">*</span></label>
                </p>
                <select id="infoModalRegime" name="cspEnfant" [(ngModel)]="assuree.assureEnfant[i].csp">
                    <option value="">Votre choix :</option>
                    <option *ngFor="let item of listeCsp; let i = index" [ngValue]="item">{{ item }}</option>
                </select>
                <p
                *ngIf="cspConjointCtrl.invalid && cspConjointCtrl.touched"
                class="error-msg erreurAffiche"
                >
                Le champ CSP enfant est obligatoire
                </p>
                </div>
                <div class="FormDroite">
                <p>
                    <label for="prenom"> Régime social</label>
                </p>
                <p>
                    <input
                    [name]="'enfantRegime_' + i"
                    type="text"
                    class="input_style"
                    [value]="enfantRegimeConverter(assuree.assureEnfants[i].regime)"
                    [disabled]="true"
                    />
                </p>
                </div>
            </div>
            <div class="ligneForm">
                <div class="FormGauche">
                <p>
                    <label for="prenom"> N° de sécurité sociale <span class="obligatoire">*</span></label>
                </p>
                <p>
                    <input
                    [(ngModel)]="assuree.assureEnfant[i].num_SS"
                    [name]="'enfantSecuriteSociale_' + i"
                    type="text"
                    class="input_style"
                    [ngClass]="{input_style: true, error: secuConjointCtrl.invalid &&
                        secuConjointCtrl.touched &&
                        !isNumSecuSocialeValid(assuree.assureConjoint.numSS)}"
                    />
                </p>
                <p
                    *ngIf="
                    secuConjointCtrl.invalid &&
                    secuConjointCtrl.touched &&
                    !isNumSecuSocialeValid(assuree.assureConjoint.num_SS)
                    "
                    class="error-msg erreurAffiche"
                >
                    N° de sécurité sociale enfant invalide.
                </p>
                </div>
                <div class="FormDroite">
                <div style="display: flex;">
                    <label>
                    Code organisme
                    <span class="obligatoire">*&nbsp;&nbsp;</span>
                    </label>
                    <div class="infobulle">
                    <img src="assets/img/info.png" alt="" />
                    <span class="infobulletext">
                        <span class="mentionObg">
                        <small for="">
                            Votre code d'organisme figure sur votre attestation d'Assurance Maladie Obligatoire sous la
                            forme d'un chiffre tel que 01 741 5143</small
                        >
                        </span>
                    </span>
                    </div>
                </div>
                <p>
                    <input
                    [(ngModel)]="assuree.assureEnfant[i].orga"
                    [name]="'codeorganismeenfant_' + i"
                    type="text"
                    class="input_style"
                    mask="000000000"
                    />
                </p>
                <p>
                    <input
                    type="checkbox"
                    [name]="'noorga_' + i"
                    [(ngModel)]="assuree.assureEnfant[i].noOrga"
                    [ngModelOptions]="{ standalone: true }"
                    style="width:30px; height:1em"
                    />
                    <label for="" class="mentionObg"
                    >Je transmettrai mon code organisme ultérieurement afin de bénéficier de la télétransmission.
                    </label>
                </p>
                <p
                *ngIf="
                    caisseConjointCtrl.invalid &&
                    caisseConjointCtrl.touched &&
                    !isCodeOrganisme(assuree.assureEnfant[i].noOrga, assuree.assureEnfant[i].orga)
                "
                class="error-msg erreurAffiche"
                >
                Vous devez renseigner un code organisme ou cocher la case.
                </p>
                </div>
            </div>
            </div> -->
        </ng-container>
      </div>
    </div>
  </div>

  <div class="MentionObligatoire">
    <p class="mentionObg">
      <span class="obligatoire">*</span> Mention obligatoire
    </p>
    <!-- <p id="agree">
      <input type="checkbox" name="agree" [(ngModel)]="jAccepte" [ngModelOptions]="{ standalone: true }" />
      <label for=""
        >J’accepte que les données saisies sur ce site soient utilisées pour effectuer la souscription de mon contrat et
        les échanges qui en découleront, conformément à la politique de confidentialité.
      </label>
    </p> -->
  </div>

  <div *ngIf="errorFraude">
    <p class="errorFraude" style="color: red; font-weight: bold">
      Nous ne sommes pas en mesure de continuer la souscription en ligne. Merci
      de contacter un conseiller au numéro indiqué dans la bandeau
    </p>
  </div>

  <div id="validation">
    <button
      type="button"
      class="validationBTN"
      (click)="validerCoordonnee()"
      [ngClass]="{
        gray: true,
        orange:
          !formulaire.invalid &&
          isCodeOrganisme(
            assuree.assurePrincipal.noOrga,
            assuree.assurePrincipal.orga
          ),
      }"
      [disabled]="
        formulaire.invalid ||
        loading ||
        !isCodeOrganisme(
          assuree.assurePrincipal.noOrga,
          assuree.assurePrincipal.orga
        )
      "
      [ngStyle]="{
        background: origine
          ? btn_bg
          : '#6D3311',
      }"
    >
      <div *ngIf="loading" class="spinner-border text-light" role="status">
        <span class="sr-only">Traitement...</span>
      </div>
      Valider et poursuivre
      <span> <img src="../../../../../../assets/img/row.svg" alt="" /></span>
    </button>
  </div>
</form>

<!-- </div> -->
